(function ($) {

    $(document).ready(function () {
        openModals();
        $(document).on('click', '[href^="#"]', openModals)
    });

    /**
     * Open modal when the hash location is changed.
     */
    function openModals(event = null) {
        let anchor = event ? $(this).attr('href') : window.location.hash;

        if (!anchor || anchor === '#') return;

        anchor = anchor.replace('#', '');

        const modalElement = document.querySelector('.modal#' + anchor);

        if (!modalElement) return;

        if (anchor === 'rules-in-video') {
            $('#rules-in-video .modal-body').html(`<iframe width="780" height="441" src="https://www.youtube.com/embed/1wvcTaZjyG4"
                        title="YouTube video player"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowfullscreen></iframe>`);
        }
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
    }

})(jQuery);



